// // // import React from 'react';
// // // import {
// // //   Dialog, DialogTitle, DialogContent, DialogActions,
// // //   Box, Typography, Chip, Link, Divider, Grid,
// // // } from '@mui/material';
// // // import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// // // import CancelIcon from '@mui/icons-material/Cancel';
// // // import { Button } from '@mui/material';
// // // import { STAGE_LABELS, WORKFLOW_LABELS } from './workflowApi';

// // // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // // const BoolChip = ({ value, yesLabel = 'Yes', noLabel = 'No' }) => (
// // //   <Chip
// // //     size="small"
// // //     icon={value ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
// // //     label={value ? yesLabel : noLabel}
// // //     color={value ? 'success' : 'default'}
// // //     variant={value ? 'filled' : 'outlined'}
// // //   />
// // // );

// // // const DocRow = ({ label, submitted, link }) => (
// // //   <Grid container alignItems="center" spacing={1} sx={{ py: 0.5 }}>
// // //     <Grid item xs={6}><Typography variant="body2">{label}</Typography></Grid>
// // //     <Grid item xs={3}><BoolChip value={submitted} yesLabel="Submitted" noLabel="Missing" /></Grid>
// // //     <Grid item xs={3}>
// // //       {link ? (
// // //         <Link href={link} target="_blank" rel="noopener" variant="body2">View File</Link>
// // //       ) : (
// // //         <Typography variant="caption" color="text.disabled">No file</Typography>
// // //       )}
// // //     </Grid>
// // //   </Grid>
// // // );

// // // const SectionTitle = ({ children }) => (
// // //   <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
// // //     {children}
// // //   </Typography>
// // // );

// // // const RecordDetailDialog = ({ open, onClose, record }) => {
// // //   if (!record) return null;
// // //   const { docs, order, payment, installments = [] } = record;

// // //   return (
// // //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// // //       <DialogTitle>
// // //         <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
// // //           <Typography variant="h6" fontWeight="bold">{record.reference_id}</Typography>
// // //           <Chip size="small" label={STAGE_LABELS[record.current_stage] || record.current_stage} color="primary" sx={{ fontWeight: 600 }} />
// // //           {record.workflow_type && (
// // //             <Chip size="small" label={WORKFLOW_LABELS[record.workflow_type] || record.workflow_type} variant="outlined" />
// // //           )}
// // //         </Box>
// // //         <Typography variant="body2" color="text.secondary">
// // //           {record.name} {record.pan_no ? `· PAN ${record.pan_no}` : ''} {record.fe_name ? `· ${record.fe_name}` : ''}
// // //         </Typography>
// // //       </DialogTitle>

// // //       <DialogContent dividers>
// // //         {/* AMOUNTS */}
// // //         <SectionTitle>Amounts</SectionTitle>
// // //         <Grid container spacing={2}>
// // //           <Grid item xs={4}>
// // //             <Typography variant="caption" color="text.secondary">Deposited</Typography>
// // //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.deposited_amount)}</Typography>
// // //           </Grid>
// // //           <Grid item xs={4}>
// // //             <Typography variant="caption" color="text.secondary">Returned</Typography>
// // //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.returned_amount)}</Typography>
// // //           </Grid>
// // //           <Grid item xs={4}>
// // //             <Typography variant="caption" color="text.secondary">Excess</Typography>
// // //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.excess_amount)}</Typography>
// // //           </Grid>
// // //         </Grid>

// // //         <Divider sx={{ my: 2 }} />

// // //         {/* ORDER STATUS */}
// // //         <SectionTitle>Order Status</SectionTitle>
// // //         {order ? (
// // //           <Grid container spacing={1.5}>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Freezing Order</Typography>
// // //               <Chip size="small" label={order.is_freezing_order_delivered || 'waiting'} color={order.is_freezing_order_delivered !== 'waiting' ? 'info' : 'default'} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Summons</Typography>
// // //               <Chip size="small" label={order.is_summons_delivered || 'waiting'} color={order.is_summons_delivered !== 'waiting' ? 'info' : 'default'} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Bank Freezed</Typography>
// // //               <BoolChip value={order.is_bank_freezed} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Partial Unfreeze Submitted</Typography>
// // //               <BoolChip value={order.is_partial_un_freezing_order_submited} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Partially Unfreezed</Typography>
// // //               <BoolChip value={order.is_partial_un_freezed} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Defreezing Submitted</Typography>
// // //               <BoolChip value={order.is_defreezing_order_submited} />
// // //             </Grid>
// // //             <Grid item xs={6} sm={4}>
// // //               <Typography variant="caption" color="text.secondary" display="block">Bank Defreezed</Typography>
// // //               <BoolChip value={order.is_bank_defreezed} />
// // //             </Grid>
// // //           </Grid>
// // //         ) : (
// // //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// // //         )}

// // //         <Divider sx={{ my: 2 }} />

// // //         {/* DOCUMENTS */}
// // //         <SectionTitle>Documents</SectionTitle>
// // //         {docs ? (
// // //           <Box>
// // //             <DocRow label="Address Proof" submitted={docs.is_address_proof_submited} link={docs.address_proof_link} />
// // //             <DocRow label="PAN Card" submitted={docs.is_pan_card_submited} link={docs.pan_card_link} />
// // //             <DocRow label="Aadhar Card" submitted={docs.is_aadhar_card_submited} link={docs.aadhar_card_link} />
// // //             <DocRow label="Affidavit" submitted={docs.is_affidavit_submited} link={docs.affidavit_link} />
// // //             <DocRow label="Bank Statement" submitted={docs.is_bank_statement_submited} link={docs.bank_statement_link} />
// // //             {(docs.current_address || docs.updated_mobile_number) && (
// // //               <Box mt={1.5}>
// // //                 {docs.current_address && (
// // //                   <Typography variant="body2" color="text.secondary">Current Address: {docs.current_address}</Typography>
// // //                 )}
// // //                 {docs.updated_mobile_number && (
// // //                   <Typography variant="body2" color="text.secondary">Updated Mobile: {docs.updated_mobile_number}</Typography>
// // //                 )}
// // //               </Box>
// // //             )}
// // //           </Box>
// // //         ) : (
// // //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// // //         )}

// // //         <Divider sx={{ my: 2 }} />

// // //         {/* PAYMENT */}
// // //         <SectionTitle>Payment Agreement</SectionTitle>
// // //         {payment ? (
// // //           <Box>
// // //             <Grid container spacing={1.5} sx={{ mb: 1 }}>
// // //               <Grid item xs={6} sm={3}>
// // //                 <Typography variant="caption" color="text.secondary" display="block">Agreed to Pay</Typography>
// // //                 <BoolChip value={payment.is_agreed_to_pay} />
// // //               </Grid>
// // //               <Grid item xs={6} sm={3}>
// // //                 <Typography variant="caption" color="text.secondary" display="block">Not Agreed</Typography>
// // //                 <BoolChip value={payment.is_not_agreed_to_pay} />
// // //               </Grid>
// // //               <Grid item xs={6} sm={3}>
// // //                 <Typography variant="caption" color="text.secondary" display="block">Agreed Amount</Typography>
// // //                 <Typography variant="body2" fontWeight={600}>{payment.agreed_amount ? fmtMoney(payment.agreed_amount) : '—'}</Typography>
// // //               </Grid>
// // //               <Grid item xs={6} sm={3}>
// // //                 <Typography variant="caption" color="text.secondary" display="block">No. of Installments</Typography>
// // //                 <Typography variant="body2" fontWeight={600}>{payment.no_of_installment || '—'}</Typography>
// // //               </Grid>
// // //             </Grid>

// // //             {(payment.agreed_amount_as_per_forensic_auditor || payment.forensic_report_link) && (
// // //               <Box sx={{ mt: 1.5, p: 1.5, bgcolor: 'grey.50', borderRadius: 1 }}>
// // //                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
// // //                   FORENSIC AUDIT
// // //                 </Typography>
// // //                 <Typography variant="body2">
// // //                   Status: {payment.forensic_auditor_status || '—'}
// // //                 </Typography>
// // //                 {payment.agreed_amount_as_per_forensic_auditor && (
// // //                   <Typography variant="body2">
// // //                     Audited Amount: {fmtMoney(payment.agreed_amount_as_per_forensic_auditor)}
// // //                   </Typography>
// // //                 )}
// // //                 {payment.forensic_report_link && (
// // //                   <Link href={payment.forensic_report_link} target="_blank" rel="noopener" variant="body2">
// // //                     View Audit Report
// // //                   </Link>
// // //                 )}
// // //               </Box>
// // //             )}

// // //             {installments.length > 0 && (
// // //               <Box sx={{ mt: 1.5 }}>
// // //                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
// // //                   INSTALLMENTS ({installments.length})
// // //                 </Typography>
// // //                 {installments.map((inst) => (
// // //                   <Box key={inst.id} display="flex" alignItems="center" gap={1.5} sx={{ py: 0.4 }}>
// // //                     <Typography variant="body2" sx={{ minWidth: 100 }}>{fmtMoney(inst.installment_amount)}</Typography>
// // //                     <Typography variant="caption" color="text.secondary" sx={{ minWidth: 110 }}>
// // //                       Due: {inst.installment_due_date || '—'}
// // //                     </Typography>
// // //                     <BoolChip value={inst.is_paid} yesLabel="Paid" noLabel="Unpaid" />
// // //                   </Box>
// // //                 ))}
// // //               </Box>
// // //             )}
// // //           </Box>
// // //         ) : (
// // //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// // //         )}
// // //       </DialogContent>
// // //       <DialogActions>
// // //         <Button onClick={onClose}>Close</Button>
// // //       </DialogActions>
// // //     </Dialog>
// // //   );
// // // };

// // // export default RecordDetailDialog;


// // import React from 'react';
// // import {
// //   Dialog, DialogTitle, DialogContent, DialogActions,
// //   Box, Typography, Chip, Link, Divider, Grid,
// // } from '@mui/material';
// // import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// // import CancelIcon from '@mui/icons-material/Cancel';
// // import { Button } from '@mui/material';
// // import { STAGE_LABELS, WORKFLOW_LABELS } from './workflowApi';

// // const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// // const BoolChip = ({ value, yesLabel = 'Yes', noLabel = 'No' }) => (
// //   <Chip
// //     size="small"
// //     icon={value ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
// //     label={value ? yesLabel : noLabel}
// //     color={value ? 'success' : 'default'}
// //     variant={value ? 'filled' : 'outlined'}
// //   />
// // );

// // const DocRow = ({ label, submitted, link }) => (
// //   <Grid container alignItems="center" spacing={1} sx={{ py: 0.5 }}>
// //     <Grid item xs={6}><Typography variant="body2">{label}</Typography></Grid>
// //     <Grid item xs={3}><BoolChip value={submitted} yesLabel="Submitted" noLabel="Missing" /></Grid>
// //     <Grid item xs={3}>
// //       {link ? (
// //         <Link href={link} target="_blank" rel="noopener" variant="body2">View File</Link>
// //       ) : (
// //         <Typography variant="caption" color="text.disabled">No file</Typography>
// //       )}
// //     </Grid>
// //   </Grid>
// // );

// // const SectionTitle = ({ children }) => (
// //   <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
// //     {children}
// //   </Typography>
// // );

// // const RecordDetailDialog = ({ open, onClose, record }) => {
// //   if (!record) return null;
// //   const { docs, order, payment, installments = [] } = record;

// //   return (
// //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// //       <DialogTitle>
// //         <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
// //           <Typography variant="h6" fontWeight="bold">{record.reference_id}</Typography>
// //           <Chip size="small" label={STAGE_LABELS[record.current_stage] || record.current_stage} color="primary" sx={{ fontWeight: 600 }} />
// //           {record.workflow_type && (
// //             <Chip size="small" label={WORKFLOW_LABELS[record.workflow_type] || record.workflow_type} variant="outlined" />
// //           )}
// //         </Box>
// //         <Typography variant="body2" color="text.secondary">
// //           {record.name} {record.pan_no ? `· PAN ${record.pan_no}` : ''} {record.fe_name ? `· ${record.fe_name}` : ''}
// //         </Typography>
// //       </DialogTitle>

// //       <DialogContent dividers>
// //         {/* AMOUNTS */}
// //         <SectionTitle>Amounts</SectionTitle>
// //         <Grid container spacing={2}>
// //           <Grid item xs={4}>
// //             <Typography variant="caption" color="text.secondary">Deposited</Typography>
// //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.deposited_amount)}</Typography>
// //           </Grid>
// //           <Grid item xs={4}>
// //             <Typography variant="caption" color="text.secondary">Returned</Typography>
// //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.returned_amount)}</Typography>
// //           </Grid>
// //           <Grid item xs={4}>
// //             <Typography variant="caption" color="text.secondary">Excess</Typography>
// //             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.excess_amount)}</Typography>
// //           </Grid>
// //         </Grid>

// //         <Divider sx={{ my: 2 }} />

// //         {/* ORDER STATUS */}
// //         <SectionTitle>Order Status</SectionTitle>
// //         {order ? (
// //           <Grid container spacing={1.5}>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Freezing Order</Typography>
// //               <Chip size="small" label={order.is_freezing_order_delivered || 'waiting'} color={order.is_freezing_order_delivered !== 'waiting' ? 'info' : 'default'} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Summons</Typography>
// //               <Chip size="small" label={order.is_summons_delivered || 'waiting'} color={order.is_summons_delivered !== 'waiting' ? 'info' : 'default'} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Bank Freezed</Typography>
// //               <BoolChip value={order.is_bank_freezed} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Partial Unfreeze Submitted</Typography>
// //               <BoolChip value={order.is_partial_un_freezing_order_submited} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Partially Unfreezed</Typography>
// //               <BoolChip value={order.is_partial_un_freezed} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Defreezing Submitted</Typography>
// //               <BoolChip value={order.is_defreezing_order_submited} />
// //             </Grid>
// //             <Grid item xs={6} sm={4}>
// //               <Typography variant="caption" color="text.secondary" display="block">Bank Defreezed</Typography>
// //               <BoolChip value={order.is_bank_defreezed} />
// //             </Grid>
// //           </Grid>
// //         ) : (
// //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// //         )}

// //         <Divider sx={{ my: 2 }} />

// //         {/* DOCUMENTS */}
// //         <SectionTitle>Documents</SectionTitle>
// //         {docs ? (
// //           <Box>
// //             <DocRow label="Address Proof" submitted={docs.is_address_proof_submited} link={docs.address_proof_link} />
// //             <DocRow label="PAN Card" submitted={docs.is_pan_card_submited} link={docs.pan_card_link} />
// //             <DocRow label="Aadhar Card" submitted={docs.is_aadhar_card_submited} link={docs.aadhar_card_link} />
// //             <DocRow label="Affidavit" submitted={docs.is_affidavit_submited} link={docs.affidavit_link} />
// //             <DocRow label="Bank Statement" submitted={docs.is_bank_statement_submited} link={docs.bank_statement_link} />
// //             {(docs.current_address || docs.updated_mobile_number) && (
// //               <Box mt={1.5}>
// //                 {docs.current_address && (
// //                   <Typography variant="body2" color="text.secondary">Current Address: {docs.current_address}</Typography>
// //                 )}
// //                 {docs.updated_mobile_number && (
// //                   <Typography variant="body2" color="text.secondary">Updated Mobile: {docs.updated_mobile_number}</Typography>
// //                 )}
// //               </Box>
// //             )}
// //           </Box>
// //         ) : (
// //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// //         )}

// //         <Divider sx={{ my: 2 }} />

// //         {/* PAYMENT */}
// //         <SectionTitle>Payment Agreement</SectionTitle>
// //         {payment ? (
// //           <Box>
// //             <Grid container spacing={1.5} sx={{ mb: 1 }}>
// //               <Grid item xs={6} sm={3}>
// //                 <Typography variant="caption" color="text.secondary" display="block">Agreed to Pay</Typography>
// //                 <BoolChip value={payment.is_agreed_to_pay} />
// //               </Grid>
// //               <Grid item xs={6} sm={3}>
// //                 <Typography variant="caption" color="text.secondary" display="block">Not Agreed</Typography>
// //                 <BoolChip value={payment.is_not_agreed_to_pay} />
// //               </Grid>
// //               <Grid item xs={6} sm={3}>
// //                 <Typography variant="caption" color="text.secondary" display="block">Agreed Amount</Typography>
// //                 <Typography variant="body2" fontWeight={600}>{payment.agreed_amount ? fmtMoney(payment.agreed_amount) : '—'}</Typography>
// //               </Grid>
// //               <Grid item xs={6} sm={3}>
// //                 <Typography variant="caption" color="text.secondary" display="block">No. of Installments</Typography>
// //                 <Typography variant="body2" fontWeight={600}>{payment.no_of_installment || '—'}</Typography>
// //               </Grid>
// //             </Grid>

// //             {(payment.agreed_amount_as_per_forensic_auditor || payment.forensic_report_link) && (
// //               <Box sx={{ mt: 1.5, p: 1.5, bgcolor: 'grey.50', borderRadius: 1 }}>
// //                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
// //                   FORENSIC AUDIT
// //                 </Typography>
// //                 <Typography variant="body2">
// //                   Status: {payment.forensic_auditor_status || '—'}
// //                 </Typography>
// //                 {payment.agreed_amount_as_per_forensic_auditor && (
// //                   <Typography variant="body2">
// //                     Audited Amount: {fmtMoney(payment.agreed_amount_as_per_forensic_auditor)}
// //                   </Typography>
// //                 )}
// //                 {payment.forensic_report_link && (
// //                   <Link href={payment.forensic_report_link} target="_blank" rel="noopener" variant="body2">
// //                     View Audit Report
// //                   </Link>
// //                 )}
// //               </Box>
// //             )}

// //             {installments.length > 0 && (
// //               <Box sx={{ mt: 1.5 }}>
// //                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
// //                   INSTALLMENTS ({installments.length})
// //                 </Typography>
// //                 {installments.map((inst) => (
// //                   <Box key={inst.id} display="flex" alignItems="center" gap={1.5} sx={{ py: 0.4 }}>
// //                     <Typography variant="body2" sx={{ minWidth: 100 }}>{fmtMoney(inst.installment_amount)}</Typography>
// //                     <Typography variant="caption" color="text.secondary" sx={{ minWidth: 110 }}>
// //                       Due: {inst.installment_due_date || '—'}
// //                     </Typography>
// //                     <BoolChip value={inst.is_paid} yesLabel="Paid" noLabel="Unpaid" />
// //                   </Box>
// //                 ))}
// //               </Box>
// //             )}
// //           </Box>
// //         ) : (
// //           <Typography variant="body2" color="text.disabled">Not started.</Typography>
// //         )}
// //       </DialogContent>
// //       <DialogActions>
// //         <Button onClick={onClose}>Close</Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default RecordDetailDialog;


// import React from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Box, Typography, Chip, Link, Divider, Grid,
// } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { Button } from '@mui/material';
// import { STAGE_LABELS, WORKFLOW_LABELS } from './workflowApi';

// const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

// const BoolChip = ({ value, yesLabel = 'Yes', noLabel = 'No' }) => (
//   <Chip
//     size="small"
//     icon={value ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
//     label={value ? yesLabel : noLabel}
//     color={value ? 'success' : 'default'}
//     variant={value ? 'filled' : 'outlined'}
//   />
// );

// const DocRow = ({ label, submitted, link }) => (
//   <Grid container alignItems="center" spacing={1} sx={{ py: 0.5 }}>
//     <Grid item xs={6}><Typography variant="body2">{label}</Typography></Grid>
//     <Grid item xs={3}><BoolChip value={submitted} yesLabel="Submitted" noLabel="Missing" /></Grid>
//     <Grid item xs={3}>
//       {link ? (
//         <Link href={link} target="_blank" rel="noopener" variant="body2">View File</Link>
//       ) : (
//         <Typography variant="caption" color="text.disabled">No file</Typography>
//       )}
//     </Grid>
//   </Grid>
// );

// const SectionTitle = ({ children }) => (
//   <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
//     {children}
//   </Typography>
// );

// const RecordDetailDialog = ({ open, onClose, record }) => {
//   if (!record) return null;
//   const { docs, order, payment, installments = [] } = record;

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//       <DialogTitle>
//         <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
//           <Typography variant="h6" fontWeight="bold">{record.reference_id}</Typography>
//           <Chip size="small" label={STAGE_LABELS[record.current_stage] || record.current_stage} color="primary" sx={{ fontWeight: 600 }} />
//           {record.workflow_type && (
//             <Chip size="small" label={WORKFLOW_LABELS[record.workflow_type] || record.workflow_type} variant="outlined" />
//           )}
//         </Box>
//         <Typography variant="body2" color="text.secondary">
//           {record.name} {record.pan_no ? `· PAN ${record.pan_no}` : ''} {record.fe_name ? `· ${record.fe_name}` : ''}
//         </Typography>
//       </DialogTitle>

//       <DialogContent dividers>
//         {/* AMOUNTS */}
//         <SectionTitle>Amounts</SectionTitle>
//         <Grid container spacing={2}>
//           <Grid item xs={4}>
//             <Typography variant="caption" color="text.secondary">Deposited</Typography>
//             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.deposited_amount)}</Typography>
//           </Grid>
//           <Grid item xs={4}>
//             <Typography variant="caption" color="text.secondary">Returned</Typography>
//             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.returned_amount)}</Typography>
//           </Grid>
//           <Grid item xs={4}>
//             <Typography variant="caption" color="text.secondary">Excess</Typography>
//             <Typography variant="body1" fontWeight={600}>{fmtMoney(record.excess_amount)}</Typography>
//           </Grid>
//         </Grid>

//         <Divider sx={{ my: 2 }} />

//         {/* ORDER STATUS */}
//         <SectionTitle>Order Status</SectionTitle>
//         {order ? (
//           <Grid container spacing={1.5}>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Freezing Order</Typography>
//               <Chip size="small" label={order.is_freezing_order_delivered || 'waiting'} color={order.is_freezing_order_delivered !== 'waiting' ? 'info' : 'default'} />
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Summons</Typography>
//               <Chip size="small" label={order.is_summons_delivered || 'waiting'} color={order.is_summons_delivered !== 'waiting' ? 'info' : 'default'} />
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Bank Freezed</Typography>
//               <BoolChip value={order.is_bank_freezed} />
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Partial Unfreeze Submitted</Typography>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <BoolChip value={order.is_partial_un_freezing_order_submited} />
//                 {order.partial_unfreeze_order_link && (
//                   <Link href={order.partial_unfreeze_order_link} target="_blank" rel="noopener" variant="caption">View</Link>
//                 )}
//               </Box>
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Partially Unfreezed</Typography>
//               <BoolChip value={order.is_partial_un_freezed} />
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Defreezing Submitted</Typography>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <BoolChip value={order.is_defreezing_order_submited} />
//                 {order.defreezing_order_link && (
//                   <Link href={order.defreezing_order_link} target="_blank" rel="noopener" variant="caption">View</Link>
//                 )}
//               </Box>
//             </Grid>
//             <Grid item xs={6} sm={4}>
//               <Typography variant="caption" color="text.secondary" display="block">Bank Defreezed</Typography>
//               <BoolChip value={order.is_bank_defreezed} />
//             </Grid>
//           </Grid>
//         ) : (
//           <Typography variant="body2" color="text.disabled">Not started.</Typography>
//         )}

//         <Divider sx={{ my: 2 }} />

//         {/* DOCUMENTS */}
//         <SectionTitle>Documents</SectionTitle>
//         {docs ? (
//           <Box>
//             <DocRow label="Address Proof" submitted={docs.is_address_proof_submited} link={docs.address_proof_link} />
//             <DocRow label="PAN Card" submitted={docs.is_pan_card_submited} link={docs.pan_card_link} />
//             <DocRow label="Aadhar Card" submitted={docs.is_aadhar_card_submited} link={docs.aadhar_card_link} />
//             <DocRow label="Affidavit" submitted={docs.is_affidavit_submited} link={docs.affidavit_link} />
//             <DocRow label="Bank Statement" submitted={docs.is_bank_statement_submited} link={docs.bank_statement_link} />
//             {(docs.current_address || docs.updated_mobile_number) && (
//               <Box mt={1.5}>
//                 {docs.current_address && (
//                   <Typography variant="body2" color="text.secondary">Current Address: {docs.current_address}</Typography>
//                 )}
//                 {docs.updated_mobile_number && (
//                   <Typography variant="body2" color="text.secondary">Updated Mobile: {docs.updated_mobile_number}</Typography>
//                 )}
//               </Box>
//             )}
//           </Box>
//         ) : (
//           <Typography variant="body2" color="text.disabled">Not started.</Typography>
//         )}

//         <Divider sx={{ my: 2 }} />

//         {/* PAYMENT */}
//         <SectionTitle>Payment Agreement</SectionTitle>
//         {payment ? (
//           <Box>
//             <Grid container spacing={1.5} sx={{ mb: 1 }}>
//               <Grid item xs={6} sm={3}>
//                 <Typography variant="caption" color="text.secondary" display="block">Agreed to Pay</Typography>
//                 <BoolChip value={payment.is_agreed_to_pay} />
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Typography variant="caption" color="text.secondary" display="block">Not Agreed</Typography>
//                 <BoolChip value={payment.is_not_agreed_to_pay} />
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Typography variant="caption" color="text.secondary" display="block">Agreed Amount</Typography>
//                 <Typography variant="body2" fontWeight={600}>{payment.agreed_amount ? fmtMoney(payment.agreed_amount) : '—'}</Typography>
//               </Grid>
//               <Grid item xs={6} sm={3}>
//                 <Typography variant="caption" color="text.secondary" display="block">No. of Installments</Typography>
//                 <Typography variant="body2" fontWeight={600}>{payment.no_of_installment || '—'}</Typography>
//               </Grid>
//             </Grid>

//             {(payment.agreed_amount_as_per_forensic_auditor || payment.forensic_report_link) && (
//               <Box sx={{ mt: 1.5, p: 1.5, bgcolor: 'grey.50', borderRadius: 1 }}>
//                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                   FORENSIC AUDIT
//                 </Typography>
//                 <Typography variant="body2">
//                   Status: {payment.forensic_auditor_status || '—'}
//                 </Typography>
//                 {payment.agreed_amount_as_per_forensic_auditor && (
//                   <Typography variant="body2">
//                     Audited Amount: {fmtMoney(payment.agreed_amount_as_per_forensic_auditor)}
//                   </Typography>
//                 )}
//                 {payment.forensic_report_link && (
//                   <Link href={payment.forensic_report_link} target="_blank" rel="noopener" variant="body2">
//                     View Audit Report
//                   </Link>
//                 )}
//               </Box>
//             )}

//             {installments.length > 0 && (
//               <Box sx={{ mt: 1.5 }}>
//                 <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
//                   INSTALLMENTS ({installments.length})
//                 </Typography>
//                 {installments.map((inst) => (
//                   <Box key={inst.id} display="flex" alignItems="center" gap={1.5} sx={{ py: 0.4 }}>
//                     <Typography variant="body2" sx={{ minWidth: 100 }}>{fmtMoney(inst.installment_amount)}</Typography>
//                     <Typography variant="caption" color="text.secondary" sx={{ minWidth: 110 }}>
//                       Due: {inst.installment_due_date || '—'}
//                     </Typography>
//                     <BoolChip value={inst.is_paid} yesLabel="Paid" noLabel="Unpaid" />
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>
//         ) : (
//           <Typography variant="body2" color="text.disabled">Not started.</Typography>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default RecordDetailDialog;


import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Chip, Link, Divider, Grid,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '@mui/material';
import { STAGE_LABELS, WORKFLOW_LABELS } from './workflowApi';

const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const BoolChip = ({ value, yesLabel = 'Yes', noLabel = 'No' }) => (
  <Chip
    size="small"
    icon={value ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
    label={value ? yesLabel : noLabel}
    color={value ? 'success' : 'default'}
    variant={value ? 'filled' : 'outlined'}
  />
);

const DocRow = ({ label, submitted, link }) => (
  <Grid container alignItems="center" spacing={1} sx={{ py: 0.5 }}>
    <Grid item xs={6}><Typography variant="body2">{label}</Typography></Grid>
    <Grid item xs={3}><BoolChip value={submitted} yesLabel="Submitted" noLabel="Missing" /></Grid>
    <Grid item xs={3}>
      {link ? (
        <Link href={link} target="_blank" rel="noopener" variant="body2">View File</Link>
      ) : (
        <Typography variant="caption" color="text.disabled">No file</Typography>
      )}
    </Grid>
  </Grid>
);

const SectionTitle = ({ children }) => (
  <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 2, mb: 1 }}>
    {children}
  </Typography>
);

const RecordDetailDialog = ({ open, onClose, record }) => {
  if (!record) return null;
  const { docs, order, payment, installments = [] } = record;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <Typography variant="h6" fontWeight="bold">{record.reference_id}</Typography>
          <Chip size="small" label={STAGE_LABELS[record.current_stage] || record.current_stage} color="primary" sx={{ fontWeight: 600 }} />
          {record.workflow_type && (
            <Chip size="small" label={WORKFLOW_LABELS[record.workflow_type] || record.workflow_type} variant="outlined" />
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {record.name} {record.pan_no ? `· PAN ${record.pan_no}` : ''} {record.fe_name ? `· ${record.fe_name}` : ''}
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {/* AMOUNTS */}
        <SectionTitle>Amounts</SectionTitle>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="caption" color="text.secondary">Deposited</Typography>
            <Typography variant="body1" fontWeight={600}>{fmtMoney(record.deposited_amount)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" color="text.secondary">Returned</Typography>
            <Typography variant="body1" fontWeight={600}>{fmtMoney(record.returned_amount)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" color="text.secondary">Excess</Typography>
            <Typography variant="body1" fontWeight={600}>{fmtMoney(record.excess_amount)}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* ORDER STATUS */}
        <SectionTitle>Order Status</SectionTitle>
        {order ? (
          <Grid container spacing={1.5}>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Freezing Order</Typography>
              <Chip size="small" label={order.is_freezing_order_delivered || 'waiting'} color={order.is_freezing_order_delivered !== 'waiting' ? 'info' : 'default'} />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Summons</Typography>
              <Chip size="small" label={order.is_summons_delivered || 'waiting'} color={order.is_summons_delivered !== 'waiting' ? 'info' : 'default'} />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Bank Freezed</Typography>
              <BoolChip value={order.is_bank_freezed} />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Partial Unfreeze Submitted</Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <BoolChip value={order.is_partial_un_freezing_order_submited} />
                {order.partial_unfreeze_order_link && (
                  <Link href={order.partial_unfreeze_order_link} target="_blank" rel="noopener" variant="caption">View</Link>
                )}
              </Box>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Partially Unfreezed</Typography>
              <BoolChip value={order.is_partial_un_freezed} />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Defreezing Submitted</Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <BoolChip value={order.is_defreezing_order_submited} />
                {order.defreezing_order_link && (
                  <Link href={order.defreezing_order_link} target="_blank" rel="noopener" variant="caption">View</Link>
                )}
              </Box>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography variant="caption" color="text.secondary" display="block">Bank Defreezed</Typography>
              <BoolChip value={order.is_bank_defreezed} />
            </Grid>
          </Grid>
        ) : (
          <Typography variant="body2" color="text.disabled">Not started.</Typography>
        )}

        <Divider sx={{ my: 2 }} />

        {/* DOCUMENTS */}
        <SectionTitle>Documents</SectionTitle>
        {docs ? (
          <Box>
            <DocRow label="Address Proof" submitted={docs.is_address_proof_submited} link={docs.address_proof_link} />
            <DocRow label="PAN Card" submitted={docs.is_pan_card_submited} link={docs.pan_card_link} />
            <DocRow label="Aadhar Card" submitted={docs.is_aadhar_card_submited} link={docs.aadhar_card_link} />
            <DocRow label="Affidavit" submitted={docs.is_affidavit_submited} link={docs.affidavit_link} />
            <DocRow label="Bank Statement" submitted={docs.is_bank_statement_submited} link={docs.bank_statement_link} />
            {(docs.current_address || docs.updated_mobile_number) && (
              <Box mt={1.5}>
                {docs.current_address && (
                  <Typography variant="body2" color="text.secondary">Current Address: {docs.current_address}</Typography>
                )}
                {docs.updated_mobile_number && (
                  <Typography variant="body2" color="text.secondary">Updated Mobile: {docs.updated_mobile_number}</Typography>
                )}
              </Box>
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="text.disabled">Not started.</Typography>
        )}

        <Divider sx={{ my: 2 }} />

        {/* PAYMENT */}
        <SectionTitle>Payment Agreement</SectionTitle>
        {payment ? (
          <Box>
            <Grid container spacing={1.5} sx={{ mb: 1 }}>
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary" display="block">Agreed to Pay</Typography>
                <BoolChip value={payment.is_agreed_to_pay} />
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary" display="block">Not Agreed</Typography>
                <BoolChip value={payment.is_not_agreed_to_pay} />
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary" display="block">Agreed Amount</Typography>
                <Typography variant="body2" fontWeight={600}>{payment.agreed_amount ? fmtMoney(payment.agreed_amount) : '—'}</Typography>
              </Grid>

              <Grid item xs={6} sm={3}>
  <Typography variant="caption" color="text.secondary" display="block">Balance (Unpaid)</Typography>
  <Typography variant="body2" fontWeight={700} color={(record.balance_amount || 0) > 0 ? 'error.main' : 'success.main'}>
    {fmtMoney(record.balance_amount || 0)}
  </Typography>
</Grid>
              <Grid item xs={6} sm={3}>
                <Typography variant="caption" color="text.secondary" display="block">No. of Installments</Typography>
                <Typography variant="body2" fontWeight={600}>{payment.no_of_installment || '—'}</Typography>
              </Grid>
            </Grid>

            {(payment.agreed_amount_as_per_forensic_auditor || payment.forensic_report_link) && (
              <Box sx={{ mt: 1.5, p: 1.5, bgcolor: 'grey.50', borderRadius: 1 }}>
                <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                  FORENSIC AUDIT
                </Typography>
                {/* <Typography variant="body2">
                  Status: {payment.forensic_auditor_status || '—'}
                </Typography> */}
                {payment.agreed_amount_as_per_forensic_auditor && (
                  <Typography variant="body2">
                    Audited Amount: {fmtMoney(payment.agreed_amount_as_per_forensic_auditor)}
                  </Typography>
                )}
                {payment.forensic_report_link && (
                  <Link href={payment.forensic_report_link} target="_blank" rel="noopener" variant="body2">
                    View Audit Report
                  </Link>
                )}
              </Box>
            )}

            {installments.length > 0 && (
              <Box sx={{ mt: 1.5 }}>
                <Typography variant="caption" fontWeight={700} color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                  INSTALLMENTS ({installments.length})
                </Typography>
                {installments.map((inst) => (
                  <Box key={inst.id} display="flex" alignItems="center" gap={1.5} sx={{ py: 0.4 }} flexWrap="wrap">
                    <Typography variant="body2" sx={{ minWidth: 100 }}>{fmtMoney(inst.installment_amount)}</Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ minWidth: 110 }}>
                      Due: {inst.installment_due_date || '—'}
                    </Typography>
                    <BoolChip value={inst.is_paid} yesLabel="Paid" noLabel="Unpaid" />
                    {inst.payment_method && (
                      <Chip size="small" variant="outlined" label={inst.payment_method} />
                    )}
                    {inst.statement_link && (
                      <Link href={inst.statement_link} target="_blank" rel="noopener" variant="caption">Statement</Link>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="text.disabled">Not started.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecordDetailDialog;